export class DeviceBoxSpaManagement {

    changeState(parameter, value) {

        const operation = 'set_' + parameter.toLowerCase()

        this._onStateChange('SPA', operation, value).then(() => {
        }).catch((e) => {

        })

    }

    tempUp(currentTemp) {
        if (currentTemp >= 40)
            return;
        this._onStateChange('SPA', 'set_preset_temp', currentTemp + 1).then(() => {

        })
    }

    tempDown(currentTemp) {
        if (currentTemp <= 16)
            return;
        this._onStateChange('SPA', 'set_preset_temp', currentTemp - 1).then(() => {

        })
    }
}

export default function HousePilotDeviceBoxSpa({ currentTemp, targetTemp, errorCode, isSanitize, isFiltering, isHeating, isPowered, error, onStateChange }) {


    const isActive = isHeating || isSanitize || isFiltering;
    const heaterValue = isHeating ? 'on' : 'off';
    const sanitizeValue = isSanitize ? 'on' : 'off';
    const filterValue = isFiltering ? 'on' : 'off';
    const powerValue = isPowered ? 'on' : 'off';

    const manager = new DeviceBoxSpaManagement()
    manager._onStateChange = onStateChange

    const infoSection = <> <i className="fa fa-power-off"></i> Allumé :  <i className={"fa fa-lg fa-toggle-" + powerValue} onClick={() => { manager.changeState('power', !isPowered) }}></i> <br />
        <i className="float-left fa fa-minus-circle" onClick={() => { manager.tempDown(targetTemp) }}></i>
        <i className="fa fa-thermometer-1"></i> Temp. <span className="italic">{currentTemp}</span> °C / <span className="italic">{targetTemp}</span> °C
        <i className="float-right fa fa-plus-circle" onClick={() => { manager.tempUp(targetTemp) }}></i>
        <br />
        <i className="fa fa-fire"></i> Chauffage : <i className={"fa fa-lg fa-toggle-" + heaterValue} onClick={() => { manager.changeState('heater', !isHeating) }}></i><br />
        <i className="fa fa-filter"></i> Désinfection : <i className={"fa fa-lg fa-toggle-" + sanitizeValue} onClick={() => { manager.changeState('sanitizer', !isSanitize) }}></i> <br />
    </>

    let errorSection = ''
    if (error) {
        errorSection = 'Impossible de récupérer les données du SPA' + JSON.stringify(error)

    }
    else if (errorCode) {
        errorSection = <i className="fa fa-solid fa-triangle-exclamation"></i> + ' ' + errorCode
    }
    return (
        <>
            <div className={"m-2 col-11 col-sm-5 col-md-6 col-lg-3 deviceBox " + (isActive === true ? ' active' : '') + (isSanitize === true ? ' cooling' : '')}>
                <h6>SPA<i className={"fa " + (isHeating ? 'fa-fire' : (isSanitize ? 'fa-shower' : 'fa-moon-o'))}  ></i></h6>
                {error ? '' : infoSection}

                {errorSection}
            </div>


        </>
    )

}
